<div class="w-full mx-auto p-5 space-y-6">

  <!-- Header y botón nuevo -->
  <div class="flex flex-wrap justify-between items-center gap-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Gestión de Tipos de Comisión</h1>
      <p class="text-gray-500 mt-1">Administra los tipos de comisión disponibles en el sistema</p>
    </div>
    <a routerLink="/config/fee-types/new"
       class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center gap-2">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"/>
      </svg>
      Nuevo Tipo de Comisión
    </a>
  </div>

  <!-- Filtro búsqueda -->
  <div class="relative w-full md:w-1/2">
    <input type="text"
           [(ngModel)]="searchTerm"
           (input)="applyFilters()"
           placeholder="Buscar tipos de comisión..."
           class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
    <svg class="w-5 h-5 absolute left-3 top-2.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
    </svg>
  </div>

  <!-- Tabla -->
  <div class="rounded-xl border border-gray-200 shadow-sm overflow-x-auto">
    <table class="w-full">
      <thead class="bg-gray-50">
      <tr>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Nombre</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Descripción</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Auditoría</th>
        <th class="px-4 py-3 text-left text-sm font-medium text-gray-700">Acciones</th>
      </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 bg-white">
      <tr *ngFor="let feeType of filteredFeeTypes" class="hover:bg-gray-50 transition">
        <td class="px-4 py-3 text-sm text-gray-800 font-medium">{{ feeType.name }}</td>
        <td class="px-4 py-3 text-sm text-gray-700">
          {{ feeType.description || 'Sin descripción' }}
        </td>
        
        <!-- 🆕 Audit Info -->
        <td class="px-4 py-3">
          <app-audit-info 
            [auditData]="getAuditData(feeType)"
            layout="horizontal"
            size="sm">
          </app-audit-info>
        </td>
        
        <td class="px-4 py-3">
          <div class="flex items-center gap-2">
            <a [routerLink]="['/config/fee-types/edit', feeType.id]"
               class="text-blue-600 hover:text-blue-800 p-2 rounded-md hover:bg-blue-50">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536M9 11l6.586-6.586a2 2 0 112.828 2.828L11.828 13.828a4 4 0 01-1.414.94l-4.121 1.373 1.373-4.121a4 4 0 01.94-1.414z"/>
              </svg>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
